import React from "react";
import { useTranslation } from "react-i18next";

const Button = (props) => {
  const { t } = useTranslation();
  const { title, handleClick, className, backgroundColor, textColor, type } =
    props;
  return (
    <button
      style={{
        backgroundColor: `${backgroundColor}`,
        color: `${textColor}`,
      }}
      type={type}
      className={className}
      onClick={handleClick}
    >
      {t(title)}
    </button>
  );
};

export default Button;
